import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useContext, useMemo } from 'react';
import { ArticleCtx } from '..';
import { Link } from '@remix-run/react';
const ArticleHashtag = (props) => {
    const { buildHref, onHashtagClick } = useContext(ArticleCtx);
    const { id, children } = props;
    const href = useMemo(() => buildHref(`/topic/${id}`), []);
    const handleClick = useCallback((e) => {
        onHashtagClick(e, { id });
    }, [onHashtagClick, id]);
    return (_jsx(Link, { className: "l8editor-forum", onClick: handleClick, to: href, children: children }));
};
export const ArticleHashtagComponentBuilder = (tag, attr) => {
    if (tag === 'a' && attr['class']?.includes('l8editor-forum')) {
        return {
            constructor: ArticleHashtag,
            props: {
                type: attr['data-type'],
                name: attr['data-name'],
                id: attr['data-id'],
            },
        };
    }
    return null;
};
